import { Modal } from 'semantic-ui-react';
import {
    QualityRequirementsPolicyType,
    SaveQualityRequirementsPolicyType,
} from '../../../../../schemas/qualityRequirementsPolicy.schemas';
import QualityRequirementsPolicyForm from '../qualityRequirementsPolicyForm';

type QualityRequirementsPolicyModalPropsType = {
    open: boolean;
    policy?: QualityRequirementsPolicyType;
    onCancel: () => void;
    onSave: (data: SaveQualityRequirementsPolicyType) => void;
};

function QualityRequirementsPolicyModal({
    open,
    policy,
    onSave,
    onCancel,
}: QualityRequirementsPolicyModalPropsType) {
    return (
        <Modal size="small" open={open} onClose={onCancel}>
            <Modal.Header>
                {policy ? 'Update Policy' : 'Create Policy'}
            </Modal.Header>
            <Modal.Content>
                <QualityRequirementsPolicyForm policy={policy} onSave={onSave} onCancel={onCancel} />
            </Modal.Content>
        </Modal>
    );
}

export default QualityRequirementsPolicyModal;
